"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var TRIGGER_INFOBOKS = "INFOBOKS";
var TRIGGER_MERKNAD = "MERKNAD";
/**
 * Utvidet veiledning typer eksportert til visningsdefinisjonen og sme-frontend
 *
 * navn: Navn på utvidet veiledning.
 * trigger: Hvor veiledningen skal vises:
 *    - som en lenke i infoboks på toppen av skattemeldingen
 *    - som et merknadskort innenfor en kortgruppe
 *    - som et merknadskort i bunnen av skattemeldingen
 * tekstNoekkel: Brukes til å lage forskjellige tekster knyttet til veiledningstypen.
 * sammneligningsfelter: Veiledningen skal sammmenligne disse feltreferansene med visningsdata for å avgjøre om det
 *    eksisterer en forekomst fra før av. Det lages da ikke nytt kort, men åpnes for å redigere det eksisterende.
 * aarsakerTilAvvisning: Liste over tilgjengelige årsaker dersom SY velger å ikke legge til opplysningene fra veiledningen.
 * skjulKortInnholdForVeiledningskort: Skal skjule detaljer om veiledning i veiledningskortet.
 * underforekomstReferanse: Referanse til kort-i-kort som skal åpnes i tilfeller det ikke eksisterer underforekomst i UV. Innført for salgskort eiendom 2024.
 * underforekomstTypeReferanse: Referanse til underforekomst for å velge riktig type når det kommer flere typer fra UV.
 *
 */ var TYPER = {
    AKSJEOPPGAVE_HOEST: {
        navn: "AKSJEOPPGAVE_HOEST",
        trigger: TRIGGER_INFOBOKS,
        tekstNoekkel: "aksjer",
        skalVisesVedAapningAvSme: true,
        besvaresMedKvitteringIDialog: true,
        sammenligningsfelter: [
            "selskapetsOrganisasjonsnummer",
            "aksjeklasse"
        ],
        aarsakerTilAvvisning: [
            "kunDisponent",
            "gjelderAnnenPart",
            "forholdAvsluttet",
            "ukjentOpplysning"
        ]
    },
    CRS_HOEST_2021: {
        navn: "CRS_HOEST_2021",
        trigger: TRIGGER_INFOBOKS,
        tekstNoekkel: "utland",
        aarsakerTilAvvisning: [
            "kunDisponent",
            "gjelderAnnenPart",
            "forholdAvsluttet",
            "ukjentOpplysning",
            "forholdErFastsatt"
        ],
        sammenligningsfelter: [
            "kontonummer"
        ]
    },
    FINANSIELL_KONTO_FRA_CRS_HOEST: {
        navn: "FINANSIELL_KONTO_FRA_CRS_HOEST",
        trigger: TRIGGER_INFOBOKS,
        tekstNoekkel: "crsHoest",
        aarsakerTilAvvisning: [
            "kunDisponent",
            "gjelderAnnenPart",
            "forholdAvsluttet",
            "ukjentOpplysning",
            "forholdErFastsatt"
        ],
        sammenligningsfelter: [
            "kontonummer"
        ]
    },
    FORDELT_NAERINGSINNTEKT_TIL_EKTEFELLE_ETTER_FASTSETTING: {
        navn: "FORDELT_NAERINGSINNTEKT_TIL_EKTEFELLE_ETTER_FASTSETTING",
        trigger: TRIGGER_INFOBOKS,
        tekstNoekkel: "naeringsinntektEtterFastsetting"
    },
    FINANSIELL_KONTO_FRA_CRS_VAAR: {
        navn: "FINANSIELL_KONTO_FRA_CRS_VAAR",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "crsVaar",
        eksempelForekomst: "konto",
        aarsakerTilAvvisning: [
            "kunDisponent",
            "gjelderAnnenPart",
            "forholdAvsluttet",
            "ukjentOpplysning"
        ]
    },
    UTLEIE_AV_FAST_EIENDOM: {
        navn: "UTLEIE_AV_FAST_EIENDOM",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "utleie",
        visRepeterendeFelt: true,
        deaktiverVelgKorttypeDialog: true,
        aarsakerTilAvvisning: [
            "skattefriLangtidsutleieEgenBolig"
        ],
        sammenligningsfelter: [
            "sergEiendomsidentifikator"
        ],
        underforekomstTypeReferanse: "utleietype"
    },
    REALISASJON_AV_EIENDOM: {
        navn: "REALISASJON_AV_EIENDOM",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "eiendomsrealisasjon",
        header: "header",
        skjulKortInnholdForVeiledningskort: true,
        aarsakerTilAvvisning: [
            "boddIBoligenOgOppfyllerEierEllerBotid",
            "bruktTilFritidsformaalOppfyllerEierEllerBrukstid",
            "pendlerEllerStudentOppfyllerEierEllerBotid",
            "skattepliktigSalgOppgittTidligere",
            "salgAvEiendomTattMedINaeringsspesifikasjon",
            "salgTasMedISkattemeldingTilEktefelleEllerSamboer",
            "gevinstEllerTapTasMedISkattemeldingTilAvdoedeDoedsboet"
        ],
        sammenligningsfelter: [
            "sergEiendomsidentifikator"
        ],
        underforekomstReferanse: "fastEiendomSomRealisasjonsobjekt"
    },
    REALISASJON_AV_EIENDOM_ARV: {
        navn: "REALISASJON_AV_EIENDOM_ARV",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "eiendomsrealisasjonArv",
        header: "header",
        skjulKortInnholdForVeiledningskort: true,
        aarsakerTilAvvisning: [
            "boddIBoligenOgOppfyllerEierEllerBotid",
            "bruktTilFritidsformaalOppfyllerEierEllerBrukstid",
            "pendlerEllerStudentOppfyllerEierEllerBotid",
            "skattepliktigSalgOppgittTidligere",
            "salgAvEiendomTattMedINaeringsspesifikasjon",
            "salgTasMedISkattemeldingTilEktefelleEllerSamboer",
            "gevinstEllerTapTasMedISkattemeldingTilAvdoedeDoedsboet"
        ],
        sammenligningsfelter: [
            "sergEiendomsidentifikator"
        ],
        underforekomstReferanse: "fastEiendomSomRealisasjonsobjekt"
    },
    SKOGEIENDOM_UTEN_TILVEKST: {
        navn: "SKOGEIENDOM_UTEN_TILVEKST",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "skogeiendomUtenTilvekst",
        header: "subHeader",
        aarsakerTilAvvisning: [
            "eierIkkeEiendommen",
            "feilEiendomstype",
            "manglerBonitetsopplysninger",
            "eiendomTasMedISkattemeldingTilEktefelleEllerSamboer",
            "ukjentOpplysning"
        ]
    },
    UTENLANDSK_AKSJE_UKJENT_GEVINST_TAP: {
        navn: "UTENLANDSK_AKSJE_UKJENT_GEVINST_TAP",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "utenlandskAksjeUkjentGevinstTap",
        header: "subHeader",
        aarsakerTilAvvisning: [
            "ukjentOpplysning",
            "gjelderAnnenPart",
            "ikkeSolgtAksjerISelskapet",
            "gevinstEllerTapErIkkeSkattepliktigEllerFradragsberettiget",
            "gevinstEllerTapTasMedISkattemeldingTilEktefelleEllerSamboer"
        ]
    },
    UTENLANDSK_AKSJE_FORRIGE_INNTEKTSAAR: {
        navn: "UTENLANDSK_AKSJE_FORRIGE_INNTEKTSAAR",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "utenlandskAksjeForrigeInntektsaar",
        header: "subHeader",
        aarsakerTilAvvisning: [
            "eierIkkeAksjene",
            "gjelderAnnenPart",
            "aksjeneErGittBortSomArvGave",
            "aksjeneErOverfoertTilAksjesparekonto",
            "aksjeneTasMedISkattemeldingTilEktefelleEllerSamboer"
        ]
    },
    EIENDOM_UTEN_NOEDVENDIG_INFO: {
        navn: "EIENDOM_UTEN_NOEDVENDIG_INFO",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "eiendomUtenNoedvendigInfo",
        header: "header",
        subHeader: "subHeader",
        deaktiverVelgKorttypeDialog: true,
        skjulKortInnholdForVeiledningskort: true,
        aarsakerTilAvvisning: [
            "eierIkkeEiendommen",
            "feilEiendomstype",
            "eiendommenHarIngenFormuesverdi",
            "eiendomTasMedISkattemeldingTilEktefelleEllerSamboer",
            "ukjentOpplysning"
        ]
    },
    AKU_UKJENT_BELOEP: {
        navn: "AKU_UKJENT_BELOEP",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "akuUkjentBeloep",
        aarsakerTilAvvisning: [
            "ikkeMottattPensjonEllerUfoereytelseFraUtlandetIAar",
            "inntektTattMedISkattemeldingTilEktefelle",
            "ikkePensjonEllerUfoereytelseMenAnnenInntektJegOppgirSelv"
        ]
    },
    AKU_KJENT_BELOEP: {
        navn: "AKU_KJENT_BELOEP",
        tekstNoekkel: "akuKjentBeloep",
        trigger: TRIGGER_MERKNAD,
        aarsakerTilAvvisning: [
            "ingenPensjonEllerUfoereytelseFraUtlandet",
            "inntektTattMedISkattemeldingTilEktefelle",
            "inntektAlleredeMedISkattemeldingen",
            "ikkePensjonEllerUfoereytelseMenAnnenInntektJegOppgirSelv"
        ]
    },
    FORDELT_NAERINGSINNTEKT_TIL_EKTEFELLE_FOER_FASTSETTING: {
        navn: "FORDELT_NAERINGSINNTEKT_TIL_EKTEFELLE_FOER_FASTSETTING",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "naeringsinntektFoerFastsetting",
        header: "subHeader"
    },
    VIRTUELL_EIENDEL: {
        navn: "VIRTUELL_EIENDEL",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "virtuellEiendel",
        aarsakerTilAvvisning: [
            "harIngenVirtuelleEiendeler"
        ]
    },
    KAPITALSKOG: {
        navn: "KAPITALSKOG",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "kapitalskog",
        header: "subHeader",
        aarsakerTilAvvisning: [
            "inntektTattMedISkattemeldingTilEktefelle",
            "gjelderAnnenPart",
            "skogdriftErIkkeEgnetTilAaGaaMedOverskudd",
            "ukjentOpplysning"
        ]
    },
    NAERINGSEIENDOM: {
        navn: "NAERINGSEIENDOM",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "naeringseiendom",
        eksempelForekomst: "utleidNaeringseiendom",
        header: "header",
        subHeader: "subHeader",
        skjulKortInnholdForVeiledningskort: true,
        annenEiendomstypeIVelgKorttypeDialog: true,
        aarsakerTilAvvisning: [
            "eierIkkeEiendommen",
            "harAldriEidEiendommen",
            "ikkeEnNaeringseiendom",
            "ukjentOpplysning",
            "eiendomTasMedISkattemeldingTilEktefelleEllerSamboer"
        ],
        sammenligningsfelter: [
            "sergEiendomsidentifikator"
        ],
        underforekomstTypeReferanse: "eiendomstype"
    },
    UTLEIE_SEKUNDAERBOLIGMODELL: {
        navn: "UTLEIE_SEKUNDAERBOLIGMODELL",
        trigger: TRIGGER_MERKNAD,
        tekstNoekkel: "sekundaerboligmodell",
        header: "header",
        skjulKortInnholdForVeiledningskort: true,
        aarsakerTilAvvisning: [
            "boligenErBeboddAvNaerstaaendeSomIkkeBetalerLeie",
            "boligenBrukesSomPendlerbolig",
            "boligenBrukesSomFritidsbolig",
            "InntektTattMedISkattemeldingenTilEktefelleEllerSamboer",
            "inntektTattMedINaeringsspesifikasjon",
            "jegBorIBoligenSelv",
            "boligenErIkkeUtleid"
        ],
        sammenligningsfelter: [
            "sergEiendomsidentifikator"
        ]
    },
    INVESTERING_I_OPPSTARTSSELSKAP: {
        navn: "INVESTERING_I_OPPSTARTSSELSKAP",
        trigger: TRIGGER_INFOBOKS,
        tekstNoekkel: "investeringIOppstartsselskap",
        header: "header",
        aarsakerTilAvvisning: [
            "kunDisponent",
            "gjelderAnnenPart",
            "forholdAvsluttet",
            "ukjentOpplysning"
        ]
    }
};
var _default = TYPER;
